export const dataSensor = {
  "ASD-GSE-01CR01-PAC002": [
    {
      Year: 2015,
      "Smoothed Deterioration": 0.961636,
    },
    {
      Year: 2016,
      "Smoothed Deterioration": 0.905218,
    },
    {
      Year: 2017,
      "Smoothed Deterioration": 0.8488,
    },
    {
      Year: 2018,
      "Smoothed Deterioration": 0.792382,
    },
    {
      Year: 2019,
      "Smoothed Deterioration": 0.735964,
    },
    {
      Year: 2020,
      "Smoothed Deterioration": 0.689702,
    },
    {
      Year: 2021,
      "Smoothed Deterioration": 0.641182,
    },
    {
      Year: 2022,
      "Smoothed Deterioration": 0.584764,
    },
    {
      Year: 2023,
      "Smoothed Deterioration": 0.528347,
    },
    {
      Year: 2024,
      "Smoothed Deterioration": 0.471929,
      Ref: "P",
    },
    {
      Year: 2025,
      "Smoothed Deterioration": 0.410997,
    },
    {
      Year: 2026,
      "Smoothed Deterioration": 0.200997,
    },
    {
      Year: 2027,
      "Smoothed Deterioration": 0,
      Ref: "F",
      "Cumulative LCC": 92409,
    },
    {
      Year: 2028,
      "Smoothed Deterioration": 0,
    },
    {
      Year: 2029,
      "Smoothed Deterioration": 0,
    },
    {
      Year: 2030,
      "Smoothed Deterioration": 0,
    },
  ],
};
